export default {
  notice_create: 'Create GCloud Business Platform Notification',
  notice_title: 'GCloud Business Platform Notification',
  notice_edit: 'Modification Suggestions',
  notice_save_draft: 'Save Draft',
  notice_send_success: 'Sent Successfully',
  notice_send_fail: 'Failed to Send',
  notice_content: 'Notification Content',
  notice_email_preview: 'Send Preview to My Email',
  notice_modify: 'Modify Notification',
  notice_new: 'Create New Notification',
  notice_method: 'Notification Method',
  notice_email: 'Email',
  notice_subject: 'Notification Title',
  notice_scope: 'Notification Scope',
  notice_content_warn: 'Please add notification items',
  notice_content_placeholder: 'Enter Notification Content',
  notice_insert_field: 'Insert Field',
  notice_myoa_reminder: 'MyOA Reminder',
  notice_myoa_toggle: 'Enable MyOA Reminder',
  notice_myoa_reminder_desc:
    'Once enabled, the internal administrators of the projects within the notification scope will receive email read confirmations for MyOA approval forms.',
  notice_publish_success: 'Published Successfully',
  notice_publish_fail: 'Failed to Publish',
  notice_review: 'Notification Review',
  notice_approve: 'Approve',
  notice_detail: 'Notification Details',
  notice_publish: 'Publish',
  notice_publish_title: '​​Release Content Confirmation​',
  notice_page_publish: 'Confirm Release​',
  notice_list_filter_tip:
    'The list only displays items matching your selected filters. To view the full list of targeted notifications, please export them from the notification details page.',
  notice_creator: 'Creator',
  notice_search: 'Search by Title',
  notice_status: 'Notification Status',
  notice_status_off: 'Disabled',
  notice_status_closed: 'Closed',
  notice_close_doc: 'Close Document',
  notice_last_update: 'Last Updated',
  notice_gcloud_biz: 'GCloud Business',
  notice_gcloud_sdk_ver: 'GCloudSDK Version',
  notice_gcloud_ver: 'GCloud Version',
  notice_component: 'Component Name',
  notice_component_ver: 'Component Version',
  notice_member_count: 'Project Team Members',
  notice_kpi_binding: 'KPI Code Binding Status',
  notice_game_selected: 'Selected',
  notice_export: 'Export List',
  notice_selected: 'Selected ',
  notice_selected_summary:
    '{{gameCount}} game project and {{memberCount}} members',
  notice_selected_summary_table:
    'contain {{gameCount}} games，{{memberCount}} members',
  notice_confirm_reset: 'Confirm to re-add projects?',
  notice_reset_warning: 'Existing added projects will be cleared',
  notice_reset: 'Re-add',
  notice_add: 'Add Project',
  notice_select_all: 'Select All',
  notice_component_ver_hint:
    'Component version (corresponding to the released GCloud version)',
  notice_search_btn: 'Search',
  notice_download_history:
    'The latest download records for selected GameIDs will be displayed in the table below',
  notice_version_filter:
    'Game projects that have downloaded the selected version will be filtered into the table below',

  notice_pending_approval: 'Pending Review',
  notice_pending_update: 'Pending Modification',
  notice_draft: 'Draft',
  notice_wait_publish: 'Pending Publication',
  notice_status_publish: 'Published',

  notice_xlsx_title: 'Notification Scope Filter Options',
  notice_xlsx_no: 'No.',
  notice_xlsx_total_info:
    'The total number of projects within the filtering range is {{total}}, and {{selectedCount}} notification project is selected',
  notice_xlsx_info:
    'Only projects confirmed for notification under the current filter conditions are displayed. Projects manually excluded from the notification scope will not appear in the list.',
  notice_xlsx_member: 'Project Members',
  notice_xlsx_admin: 'Project Administrators',
  notice_xlsx_other: 'Other Members',
  notice_xlsx_success: 'Notification project list exported successfully',
  notice_xlsx_fail:
    'Failed to export notification project list, please try again',
  notice_xlsx_filename_prefix: 'project_notification_list​',
};
